import * as React from "react";
import { useCurrentUserPrincipal } from "../../../services/UserServices/UserService";
import { Navigate } from "react-router-dom";
import { Loading } from "@ui/molecules/Loading/Loading";

export type IProtectedComponentProps = {
	redirectPath?: string;
	children?: JSX.Element | null;
	serverRedirect?: boolean;
	requireAllRoles?: boolean;
} & ({ authenticated: true; roles?: string[] } | { authenticated?: false; roles: string[] });

export function ProtectedComponent(props: IProtectedComponentProps): JSX.Element | null {
	const up = useCurrentUserPrincipal();

	const requiredRoles = React.useMemo(() => {
		const reqRoles = props.roles || [];
		const allReqRoles = props.authenticated ? ["authenticated", ...reqRoles] : reqRoles;
		return allReqRoles;
	}, [props.roles, props.authenticated]);

	const hasRoles = React.useMemo(() => {
		if (!up.principal?.clientPrincipal) return false;

		const roles = up.principal?.clientPrincipal?.userRoles;

		const includedRoles = requiredRoles.map((i) => roles?.includes(i));

		return props.requireAllRoles ? includedRoles.every((i) => i) : includedRoles.find((i) => i);
	}, [up.principal, props.requireAllRoles, requiredRoles]);

	React.useEffect(() => {
		if (!up.isLoading && props.serverRedirect && !hasRoles && props.redirectPath) {
			window.location.href = props.redirectPath;
		}
	}, [hasRoles, up.isLoading, props.serverRedirect, props.redirectPath]);
	if (up.isLoading) {
		return <Loading></Loading>;
	} else if (!!props.redirectPath && !hasRoles && !props.serverRedirect) {
		return <Navigate to={props.redirectPath} replace></Navigate>;
	} else if (!!props.redirectPath && !hasRoles && props.serverRedirect) {
		return <Loading></Loading>;
	} else if (hasRoles) return <>{props.children}</>;
	else return <></>;
}
